/**
 * Buttons and counter for <magnify-dialog> (assets/magnify-dialog.js).
 *
 * Labels arrive localized on the <product-modal> tag as data-magnify-*
 * (snippets/product-media-modal.liquid), so this file holds no shopper-facing
 * text. Everything is built with DOM calls, never an HTML string, so a
 * translation can never inject markup.
 */
window.MagnifyControls = Object.freeze({
  render(labels) {
    const button = (name, label, text) => {
      const node = document.createElement('button');
      node.type = 'button';
      node.className = `magnify-dialog__button magnify-dialog__button--${name}`;
      node.setAttribute('aria-label', label || '');
      node.textContent = text;
      return node;
    };
    const group = (name, label, nodes) => {
      const node = document.createElement('div');
      node.className = `magnify-dialog__group magnify-dialog__group--${name}`;
      node.setAttribute('role', 'group');
      node.setAttribute('aria-label', label || '');
      node.append(...nodes);
      return node;
    };

    const buttons = {
      previous: button('previous', labels.magnifyPrevious, '‹'),
      next: button('next', labels.magnifyNext, '›'),
      zoomOut: button('zoom-out', labels.magnifyZoomOut, '−'),
      zoomIn: button('zoom-in', labels.magnifyZoomIn, '+'),
      reset: button('reset', labels.magnifyResetLabel, labels.magnifyReset || ''),
    };
    const counterNode = document.createElement('span');
    counterNode.className = 'magnify-dialog__counter';
    counterNode.setAttribute('aria-live', 'polite');
    const levelNode = document.createElement('span');
    levelNode.className = 'magnify-dialog__level';
    levelNode.setAttribute('role', 'status');
    levelNode.textContent = '100%';

    const root = document.createElement('div');
    root.className = 'magnify-dialog__controls';
    root.append(
      group('navigation', labels.magnifyNavigation, [buttons.previous, counterNode, buttons.next]),
      group('zoom', labels.magnifyControls, [buttons.zoomOut, levelNode, buttons.zoomIn, buttons.reset])
    );

    return {
      root,
      buttons,
      nodes: { previousButton: buttons.previous, nextButton: buttons.next, counterNode, levelNode },
    };
  },

  /** Short on screen ("2 / 6"), a full sentence for screen readers. */
  update(dialog, index, count, spokenTemplate) {
    const fill = (template) => template.replace('[index]', index + 1).replace('[count]', count);
    const visible = document.createElement('span');
    visible.setAttribute('aria-hidden', 'true');
    visible.textContent = fill('[index] / [count]');
    const spoken = document.createElement('span');
    spoken.className = 'visually-hidden';
    spoken.textContent = fill(spokenTemplate || '[index] / [count]');
    dialog.counterNode.replaceChildren(visible, spoken);
    dialog.previousButton.disabled = index <= 0;
    dialog.nextButton.disabled = index >= count - 1;
  },
});
